<mat-toolbar fxLayout="row" fxLayoutAlign="end">
  <div fxLayout="column" fxLayoutAlign="center">
    <button mat-flat-button color="primary" matTooltip="Create a new microsite" (click)="createNewClicked.emit()">Create new</button>
  </div>
</mat-toolbar>
